<template>
  <div id="app">
    <loading-modal v-if="loading" />
    <error-modal-card v-if="error" :body="errorModalBody" :retryButton="false" :closeButton="true" @close="closeErrorModal"/>
    <router-view class="max-h-screen"/>
  </div>
</template>

<script>
  import axios from 'axios';
  import ErrorModalCard from './components/modals/ErrorModalCard';
  import LoadingModal from './components/modals/LoadingModal';

  export default {
    name: 'app',
    components: {
      ErrorModalCard,
      LoadingModal,
    },
    data() {
      return {
        error: false,
        loading: false,
        errorModalBody: '',
      };
    },
    created() {
      // https://github.com/axios/axios#interceptors
      // Add a request interceptor
      axios.interceptors.request.use((config) => {
        this.loading = true;
        return config;
      }, (error) => {
        this.showAxiosError(error);
        return Promise.reject(error);
      });

      // Add a response interceptor
      axios.interceptors.response.use((response) => {
        this.loading = false;
        return response;
      }, (error) => {
        this.showAxiosError(error);
        return Promise.reject(error);
      });
    },
    methods: {
      showAxiosError(error) {
        if (error.response.data.message === 'No ride for this driver today yet'
          || error.response.data.message === 'The user credentials were incorrect.') {
          this.loading = false;
          return;
        }

        this.loading = false;
        this.error = true;

        if (error.response && Number(error.response.status) === 401) {
          this.$router.push({ name: 'login' });
        }

        let errorMessage = '';

        error.response.data.errors.status.forEach((item) => {
          errorMessage += item;
          errorMessage += '\n';
        });

        this.errorModalBody = errorMessage;
      },
      closeErrorModal() {
        this.error = false;
        this.errorModalBody = '';
      },
    },
  };
</script>

<style lang="scss">
  @import './assets/scss/main.scss';
</style>
